import '../products_category/ProductsCategory.css';
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Container, Row, Col } from "react-bootstrap";
import Vegetable from "./icon/Vegetable-icon.png";
import fruitsIcon from "./icon/Fruits-icon.png";
import greenVegetableIcon from "./icon/Green Vegetable-icon.png";
import onionIcon from "./icon/Onion-icon.png";
import vegetableIcon1 from "./icon/Vegetable-icon1.png";
import lemonIcon from "./icon/Lemon-icon.png";

const data = {
  items: [
    {
      img: "imeges/white broccoli.png",
      category: "fruits"
    },
    {
      img: "imeges/orange.jpg",
      category: " Fruits green-vegetable"
    },
    {
      img: "imeges/strawberry.jpg",
      category: "Fruits onion"
    },
    {
      img: "imeges/yellow orange.jpg",
      category: "Fruits vegetable"
    },
    {
      img: "imeges/avocado.jpg",
      category: " Fruits lemon"
    },
    {
      img: "imeges/tomato.jpg",
      category: "fruits"
    },
    {
      img: "imeges/jamun.jpg",
      category: "Fruits green-vegetable"
    },
    {
      img: "imeges/Cherry.jpg",
      category: " Fruits onion"
    },
    {
      img: "imeges/green lamon.jpg",
      category: "vegetable"
    },
    {
      img: "imeges/tomato 1.jpg",
      category: "lemon"
    },
    {
      img: "imeges/broccoli.jpg",
      category: "fruits"
    },
    {
      img: "imeges/onion.jpg",
      category: "green-vegetable"
    }
  ]
};

export default function App() {
  const [displayData, setDisplayData] = useState(data.items);
  const [active, setActive] = useState("all");

  const handleCategoryClick = (category) => {
    if (category === active) return;
    setActive(category);
    setDisplayData([]);

    if (category === "all") {
      setDisplayData(data.items);
      return;
    }

    const filteredData = data.items.filter((item) =>
      item.category.includes(category)
    );

    setTimeout(() => {
      setDisplayData(filteredData);
    }, 400);
  };

  const FilterBar = ({ handleClick, active }) => {
    const items = [
      { text: "All", icon: Vegetable },
      { text: "Fruits", icon: fruitsIcon },
      { text: "Green Vegetable", icon: greenVegetableIcon },
      { text: "Onion", icon: onionIcon },
      { text: "Vegetable", icon: vegetableIcon1 },
      { text: "Lemon", icon: lemonIcon }
    ];

    return (
      <Row>
        <Col lg={3}>
          <Row style={{rowGap: "40px"}}>
            <Col lg={12} style={{backgroundColor: "#FAFAFA", borderRadius:"25px"}}>
            <ul className="button-list">
          {items.map((item) => (
            <li key={item.text}>
              <button
                className={`btn button-list-btn ${active === item.text.toLowerCase() && "active"}`}
                onClick={() => handleClick(item.text.toLowerCase())}
              >
                {item.icon && <img src={item.icon} alt="" />}
                {item.text}
              </button>
            </li>
          ))}
        </ul>
            </Col>
            <Col lg={12}>
             <div class="products_inner">
                <div class="products_inner_main">
                  <h2>Fruits For Live<br/> Healthy</h2>
                  <p>Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet,consectetur adipiscing elit.</p>
                  <a href="#">Shop Now</a>
                </div>
              </div>
            </Col>
            <Col lg={12}>
              <div class="products_inne">
                  <div class="products_inner_main">
                    <h2>Fruits For Live <br/> Healthy</h2>
                    <p>Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet,consectetur adipiscing elit.</p>
                    <a href="#">Shop Now</a>
                  </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col lg={9}>
          <Row  style={{rowGap: "20px"}}>
            <AnimatePresence>
              {displayData.map(({ img, category }, i) => (
                <Col xs={6} lg={4} sm={6} md={4} key={i}>
                  <motion.div
                    style={{ overflow: "hidden" }}
                    layout
                    initial={{ transform: "scale(0)" }}
                    animate={{ transform: "scale(1)" }}
                    exit={{ transform: "scale(0)" }}
                  >
                    <div className="white_broccoli">
                      <div className="white_broccoli_manu">
                        <img src={img} className="w-100" alt="" />
                        <div className="white_broccoli_overlay">
                          <div className="icon">
                            <i className="fa-regular fa-heart"></i>
                          </div>
                          <div className="icon">
                            <i className="fa-solid fa-bag-shopping"></i>
                          </div>
                          <div className="icon">
                            <i className="fa-regular fa-eye"></i>
                          </div>
                        </div>
                        <ul className="icson">
                          <li className="icon_star">
                            <i className="fa-solid fa-star"></i>
                          </li>
                          <li className="icon_star">
                            <i className="fa-solid fa-star"></i>
                          </li>
                          <li className="icon_star">
                            <i className="fa-solid fa-star"></i>
                          </li>
                          <li className="icon_star">
                            <i className="fa-solid fa-star"></i>
                          </li>
                          <li className="icon_star">
                            <i className="fa-solid fa-star"></i>
                          </li>
                        </ul>
                      </div>
                      <div className="white_broccoli_text">
                        <h3 className="item-name">Organic Vegetables</h3>
                        <h5 className="item-price">$8.00-9.00</h5>
                      </div>
                    </div>
                  </motion.div>
                </Col>
              ))}
            </AnimatePresence>
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <section id="products_category">
      <Container>
        <div className="App">
          <FilterBar active={active} handleClick={handleCategoryClick} />
        </div>
      </Container>
    </section>
  );
}
